
<div class="resanotif">
  <v-touch class="resanotif-container" v-on:pan="panEvent" v-on:panend="panEnd" v-on:pancancel="panCancel"
    v-on:tap="reInitPos">
    <div class="resanotif-left" @click="cancelResa">Refuser</div>
    <el-row :gutter="10" class="resanotif-row" v-bind:style="{ left: swipContentValue }">
      <el-col :span="2">
        <div class="resanotif-point"></div>
      </el-col>
      <el-col :span="18">
        <div class="resanotif-info">
          <div class="resanotif-info-title">Nouvelle réservation</div>
          <div class="resanotif-info-desc">
            <span v-if="getClientByid(resa.cid)">{{ getClientByid(resa.cid).name }} {{ getClientByid(resa.cid).prenom
              }} -
              {{ resa.nbCouvert }} couverts</span>
            <span v-if="resa.type === 'caution' && resa.amount > 0"> - C : </span>
            <span v-if="resa.type === 'prepaiement' && resa.amount > 0"> - P : </span>
            <span v-if="resa.total">{{ resa.total }}€</span>
            <span v-else-if="resa.amount !== '' && resa.amount > 0">{{ Math.round((resa.amount * resa.nbCouvert) *
              100)
              / 100}}€</span><br>
            le {{ resa.dateResa.day }} {{ resa.dateResa.labelMonth }} {{ resa.dateResa.year }} à {{
              getHourWithH(resa.hour) }}
          </div>
        </div>
      </el-col>
      <el-col :span="4" class="resanotif-btn-container">
        <div class="resanotif-btn" @click="gotoResa">
          <i class="el-icon-more"></i>
        </div>
      </el-col>
    </el-row>
    <div class="resanotif-right" @click="callAccept">Accepter</div>
  </v-touch>
  <div class="resanotif-separator"></div>
</div>
